import { AnyAction } from 'redux';

export const INIT = 'app/OrganizationsListPage/INIT';
export const INIT_SUCCESS = 'app/OrganizationsListPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/OrganizationsListPage/INIT_FAILED';

export const SET_FETCH_PARAMS = 'app/OrganizationsListPage/SET_FETCH_PARAMS';
export const FETCH_SUCCESS = 'app/OrganizationsListPage/FETCH_SUCCESS';
export const FETCH_FAILED = 'app/OrganizationsListPage/FETCH_FAILED';

export const FETCH_DONATIONS_TOTAL = 'app/OrganizationsListPage/FETCH_DONATIONS_TOTAL';
export const FETCH_DONATIONS_TOTAL_SUCCESS =
  'app/OrganizationsListPage/FETCH_DONATIONS_TOTAL_SUCCESS';
export const FETCH_DONATIONS_TOTAL_FAILED =
  'app/OrganizationsListPage/FETCH_DONATIONS_TOTAL_FAILED';

export const FETCH_VOLUNTEERHOURS_TOTAL = 'app/OrganizationsListPage/FETCH_VOLUNTEERHOURS_TOTAL';
export const FETCH_VOLUNTEERHOURS_TOTAL_SUCCESS =
  'app/OrganizationsListPage/FETCH_VOLUNTEERHOURS_TOTAL_SUCCESS';
export const FETCH_VOLUNTEERHOURS_TOTAL_FAILED =
  'app/OrganizationsListPage/FETCH_VOLUNTEERHOURS_TOTAL_FAILED';

export const FETCH_DEEDS_TOTAL = 'app/OrganizationsListPage/FETCH_DEEDS_TOTAL';
export const FETCH_DEEDS_TOTAL_SUCCESS = 'app/OrganizationsListPage/FETCH_DEEDS_TOTAL_SUCCESS';
export const FETCH_DEEDS_TOTAL_FAILED = 'app/OrganizationsListPage/FETCH_DEEDS_TOTAL_FAILED';

export const UNBLOCK_NONPROFIT = 'app/OrganizationDetailsPage/UNBLOCK_NONPROFIT';
export const UNBLOCK_NONPROFIT_SUCCESS = 'app/OrganizationDetailsPage/UNBLOCK_NONPROFIT_SUCCESS';
export const UNBLOCK_NONPROFIT_FAILED = 'app/OrganizationDetailsPage/UNBLOCK_NONPROFIT_FAILED';

export const UNBLOCK_NONPROFIT_NONPROFIT_FORM_IDENTIFIER =
  'app/containers/OrganizationsListPage/unblockNonprofitForm';

export const init = (): AnyAction => ({
  type: INIT,
});

export interface Init {
  type: typeof INIT;
}

export const initSuccess = (total: number): AnyAction => ({
  type: INIT_SUCCESS,
  total,
});

export const setFetchParamsAction = (params: any): AnyAction => ({
  type: SET_FETCH_PARAMS,
  params,
});

export interface FetchParams {
  type: typeof SET_FETCH_PARAMS;
}

export const fetchFailed = (error: Error): AnyAction => ({
  type: FETCH_FAILED,
  error,
});

export const fetchSuccess = (total: number): AnyAction => ({
  type: FETCH_SUCCESS,
  total,
});

export const fetchDonationsTotal = (): AnyAction => ({
  type: FETCH_DONATIONS_TOTAL,
});

export const fetchDonationsTotalSuccess = (donationsTotal: number): AnyAction => ({
  type: FETCH_DONATIONS_TOTAL_SUCCESS,
  donationsTotal,
});

export const fetchDonationsTotalFailed = (error: Error): AnyAction => ({
  type: FETCH_DONATIONS_TOTAL_FAILED,
  error,
});

export const fetchVolunteerTimesTotal = (): AnyAction => ({
  type: FETCH_VOLUNTEERHOURS_TOTAL,
});

export const fetchVolunteerTimesTotalSuccess = (volunteerHoursTotal: number): AnyAction => ({
  type: FETCH_VOLUNTEERHOURS_TOTAL_SUCCESS,
  volunteerHoursTotal,
});

export const fetchVolunteerTimesTotalFailed = (error: Error): AnyAction => ({
  type: FETCH_VOLUNTEERHOURS_TOTAL_FAILED,
  error,
});

export const fetchDeedsTotal = (): AnyAction => ({
  type: FETCH_DEEDS_TOTAL,
});

export const fetchDeedsTotalSuccess = (deedsTotal: number): AnyAction => ({
  type: FETCH_DEEDS_TOTAL_SUCCESS,
  deedsTotal,
});

export const fetchDeedsTotalFailed = (error: Error): AnyAction => ({
  type: FETCH_DEEDS_TOTAL_FAILED,
  error,
});

export const unblockNonprofitAction = (id: string): AnyAction => ({
  type: UNBLOCK_NONPROFIT,
  id,
});

export const unblockNonprofitSuccessAction = (): AnyAction => ({
  type: UNBLOCK_NONPROFIT_SUCCESS,
});

export const unblockNonprofitFailedAction = (error: any): AnyAction => ({
  type: UNBLOCK_NONPROFIT_FAILED,
  error,
});
